<template>
  <div >


    <card class="card" :title="title" style="color:blue;font-size: 30px;">
    <div>
      <ul class="list-unstyled team-members">
        <li>
          <div class="row text-center" v-for="num in numeros" :key="num.id">
            <!-- <div class="col-3 justify-content-center d-flex" >
              <div class="avatar">
                <img
                  :src="rutaApp +'storage/documents/' + num.Foto"
                  alt="N"
                  class="rounded img-fluid"
                />
              </div>
            </div> -->
            <div class="col-12 justify-content-center aling-items-center " v-if="num.Interno">
              <p class="text-white py-3" style="background-color: #003f8a;"> <b style="color: #ffcc00;"> {{ num.Reparticion }} </b> </p>

              <div class="row align-items-center mb-0 pb-0">
                  <p class=" col-lg-6 col-sm-12 text-info mb-0 pb-0"> Interno </p>
                  <p class="col-lg-6 col-sm-12 text-info mb-0 pb-0"> Corporativo </p>
              </div>

              <div class="row align-items-center">
                  <h4 class="col-lg-6 col-sm-12 text-success" v-if="num.Interno">  <i class="ti-bookmark"></i>   {{ num.Interno }} </h4>
                  <p class=" col-lg-6 col-sm-12 text-danger" v-if="!num.Interno"> No se tiene registrado el interno </p>
                  <h4 class=" col-lg-6 col-sm-12 text-secondary" v-if="num.Corporativo">  <i class="ti-bookmark"></i>   {{ num.Corporativo }} </h4>
                  <p class="col-lg-6 col-sm-12 text-warning" v-if="!num.Corporativo"> No se tiene registrado el número corporativo </p>
              </div>


              <!-- <div class="row ">
                <p class=" col-6 text-danger" v-if="!num.Interno"> No se tiene registrado el interno </p>
                <p class="col-6 text-danger" v-if="!num.Corporativo"> No se tiene registrado el número corporativo </p>
              </div> -->
              <hr>

            </div>




   

            
          </div>

        </li>
      </ul>
    </div>

    


  </card>

  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
// import Chartist from "chartist";
import MainService from "@/services/MainService.js";

export default {

  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },
  
  components: {
    StatsCard,
    ChartCard,
  },

  data() {
    return {
      ss: new MainService(),

      paginas: [
        {
          type: "primary",
          icon: "ti-world",
          title: "PAGINA WEB ",
          value: "EMI",
          footerText: "http://emi.edu.bo/",
          footerIcon: "ti-arrow-right",
        },
      
      ],

      numeros:[],
      

    };
  },

   methods: {
  
    showPersona() {
      console.log("show");
            
            this.ss.showPersona(this.auth.id).then(
                (result) => {
                    let response = result.data;
                    this.persona = response.data;
                    console.log(this.persona);

                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
    },

    getReparticionesNumero() {    

        this.ss.listReparticionesNumero(this.auth.UnidadAcademica).then(
            (result) => {
                let response = result.data;
                this.numeros = response.data;               
            }
        ).catch(error => {
            console.log(error);
            this.isLoading=false;
        });
    },

  },

   mounted() {
        this.auth = JSON.parse(localStorage.getItem('usuario'));
        console.log(this.auth);
        if (!this.auth) {
            this.$router.push('/Login');
        } else {
            
            this.getReparticionesNumero();
            
        }
    }
};
</script>
<style></style>
